import ISO6391 from 'iso-639-1';

const allLanguages = ISO6391.getAllCodes();
export const getLanguageName = (language: string) => ISO6391.getName(language);

export const priorLanguages: string[] = ['en', 'es'];
export const prettyAllLanguages: string[] = ISO6391.getAllNames();

export const listOfAllLanguages: string[] = allLanguages.sort((a, b) => {
  if (!priorLanguages.includes(a) && priorLanguages.includes(b)) return 1;
  if (priorLanguages.includes(a) && !priorLanguages.includes(b)) return -1;
  if (priorLanguages.includes(a) && priorLanguages.includes(b))
    return priorLanguages.indexOf(a) > priorLanguages.indexOf(b) ? 1 : -1;
  return getLanguageName(a).localeCompare(getLanguageName(b));
});
